import React, {memo} from "react";
import PropTypes from "prop-types";
import {FaEllipsisV} from "react-icons/fa";
import {Popup} from "reactjs-popup";
import "./style.scss";

const PopoverComponent = (props) => {
  const {
    children,
    icon: Icon = FaEllipsisV,
    position = ["bottom left", "bottom right", "top left", "top right"],
    contentZIndex,
  } = props;

  return (
    <Popup
      trigger={
        <span
          style={{
            cursor: "pointer",
            padding: "0px 10px",
          }}
          data-cy="selectList"
        >
          <Icon aria-hidden="true" />
        </span>
      }
      position={position}
      contentStyle={{
        ...(contentZIndex && {zIndex: contentZIndex}),
      }}
    >
      {(close) => (
        <div
          className="popover-container"
          role="button"
          tabIndex={0}
          onClick={close}
          onKeyDown={close}
        >
          {children}
        </div>
      )}
    </Popup>
  );
};

PopoverComponent.propTypes = {
  /** This element will be displayed when popover is opened */
  children: PropTypes.element.isRequired,
  /** On click of this icon popover will be opened.
   *  This is icon component from react-icons library which will be used as Element
   */
  icon: PropTypes.elementType,
  /** Element deciding popover position when opened */
  position: PropTypes.oneOf(["bottom left", "bottom right", "top left", "top right"]),
  /** Number defining the stack order of the popover when opened */
  contentZIndex: PropTypes.number,
};

export default memo(PopoverComponent);
